<template>
    <div ref="messagesWidget" class="dropdown mailbox-dropdown-vue mr-1" :class="{ show: dropdownShown }">

        <BLink href="#" @click.prevent="toggleDropdown" class="p-1 link-block rounded-circle" :class="{active: isActive([mailboxPath])}" v-ripple>
            <i class="mi-mail-outline top-0 mi-1-5x"></i>
            <span class="badge-message" v-if="unreadMessages > 0">{{ unreadMessages }}</span>
        </BLink>

        <div class="dropdown-menu right-0 left-auto mx-auto messages-menu p-0" :class="{ show: dropdownShown }">
            <div class="dropdown-header py-0">
                <div class="row flex-grow-1 flex-nowrap align-items-center justify-content-between">
                    <div class="col-auto">
                        <span class="text-uppercase">Messages</span><span v-if="unreadMessages > 0" class="ml-1">({{unreadMessages}})</span>
                    </div>

                    <div class="col-auto" v-if="showMarkAllAsReadButton">
                        <a class="font-weight-semibold font-size-xs" href="#" @click.prevent="markAllAsRead">
                            Mark all as read
                        </a>
                    </div>
                </div>
            </div>

            <WidgetMessage @close="dropdownShown = false" v-for="message in messages" :key="message.id" :message="message"/>

            <div class="justify-content-center no-messages-placeholder" v-if="messages.length === 0">
                <i class="icon-mailbox empty-activity"></i>
                There are no messages for you in this project
            </div>


            <div class="dropdown-header py-0">
                <a :href="`/${mailboxPath}`" class="ml-auto mr-auto btn a-go-to-mailbox" @click="dropdownShown = false">Go to mailbox</a>
            </div>

            <div class="position-absolute top-0 right-0 bottom-0 left-0 align-items-center justify-content-center"
                 style="background-color: rgba(55, 71, 79, .7);" :class="{ 'd-flex': waitingResponse, 'd-none': !waitingResponse }">
                <i class="icon-spinner4 spinner"></i>
            </div>
        </div>

        <div v-if="!messagesFetched" class="position-absolute top-0 right-0 bottom-0 left-0 align-items-center justify-content-center rounded-circle"
             style="background-color: rgba(255, 255, 255, 0.5);" :class="{ 'd-flex': waitingResponse, 'd-none': !waitingResponse }">
            <i class="icon-spinner4 spinner font-size-sm"></i>
        </div>
    </div>
</template>

<script>
import WidgetMessage from './WidgetMessage';
import {GET_MESSAGES, MARK_AS_READ_MESSAGES} from "@/store/navbar/actions";
import {BLink} from "bootstrap-vue";
import EventBus, {MAIN_WINDOW_CLICK} from "@/utils/event-bus";
import {mapState} from "vuex";
import mixinNavbar from "@/mixins/navbar/mixin";

export default {
    name: 'MessagesWidget',
    components: {
        BLink,
        WidgetMessage
    },
    data() {
        return {
            messages: [],
            unreadMessages: 0,
            dropdownShown: false,
            messagesFetched: false,
            waitingResponse: false
        }
    },
    computed: {
        ...mapState({
            projectId: state => state.navbar.projectId,
            unreadMessagesState: state => state.navbar.unreadMessages,
        }),
        showMarkAllAsReadButton() {
            return this.messages.some(function(message) {
                return message.recipientStatus && message.recipientStatus === 10;
            });
        },
        mailboxPath: vm => `project/${vm.projectId}/mailbox`
    },
    methods: {
        toggleDropdown() {
            if (this.messagesFetched) {
                this.dropdownShown = !this.dropdownShown;
                return;
            }

            if (this.waitingResponse) {
                return;
            }

            this.waitingResponse = true;

            this.$store.dispatch(GET_MESSAGES, {
                expand: 'contentCutted,dateString,topic,senderName,senderRoleName,recipientStatus',
                'per-page': 6
            })
                .then(this.onSuccess)
                .catch(this.onError);
        },
        onSuccess(payload) {
            this.messages = payload.data;

            this.waitingResponse = false;
            this.messagesFetched = true;
            this.dropdownShown = !this.dropdownShown;
        },
        onError() {
            this.waitingResponse = false;
        },
        markAllAsRead() {
            if (this.waitingResponse) {
                return;
            }

            this.waitingResponse = true;

            var ids = this.messages.filter(function(message) {
                return message.recipientStatus === 10;
            }).map(function(message) {
                return message.id;
            });

            this.$store.dispatch(MARK_AS_READ_MESSAGES, { id: ids })
                .then(this.onMarkSuccess)
                .catch(this.onMarkError);
        },
        onMarkSuccess() {
            for (var i = 0; i < this.messages.length; ++i) {
                if (10 == this.messages[i].recipientStatus) {
                    this.messages[i].recipientStatus = 20;
                    --this.unreadMessages;
                }
            }

            this.waitingResponse = false;
        },
        onMarkError() {
            this.waitingResponse = false;
        },
        onWindowClick(event) {
            if (
                this.$refs?.messagesWidget
                && this.$refs.messagesWidget !== event.target
                && !this.$refs.messagesWidget.contains(event.target)
            ) {
                this.dropdownShown = false;
            }
        }
    },
    watch: {
        unreadMessagesState: {
            handler(v) {
                this.unreadMessages = v;
            },
            immediate: true
        }
    },
    mounted() {
        EventBus.on(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    destroyed() {
        EventBus.off(MAIN_WINDOW_CLICK, this.onWindowClick);
    },
    mixins: [mixinNavbar],
}
</script>
